import { supabase } from '@/integrations/supabase/client';
import { OSData } from '@/types/reprocessamento';

const PAGE_SIZE = 1000;

export const fetchOrdensServico = async (
  dataInicio: string,
  dataFim: string,
  numeroOS: string,
  funcionario?: string
): Promise<OSData[]> => {
  if (numeroOS) {
    const { data, error } = await supabase
      .from('ordens_servico')
      .select(
        'numero, operador_nome, data_real, horas_totais, horas_faturadas, empresa_nome, status_descricao, valor_a_pagar'
      )
      .eq('numero', numeroOS)
      .not('operador_nome', 'is', null)
      .not('data_real', 'is', null)
      .not('horas_totais', 'is', null);

    if (error) throw error;
    return (data as OSData[]) || [];
  }

  const all: OSData[] = [];
  for (let from = 0; ; from += PAGE_SIZE) {
    let q = supabase
      .from('ordens_servico')
      .select(
        'numero, operador_nome, data_real, horas_totais, horas_faturadas, empresa_nome, status_descricao, valor_a_pagar'
      )
      .not('operador_nome', 'is', null)
      .not('data_real', 'is', null)
      .not('horas_totais', 'is', null)
      .order('data_real', { ascending: true })
      .order('numero', { ascending: true });

    if (dataInicio) q = q.gte('data_real', dataInicio);
    if (dataFim) q = q.lte('data_real', dataFim);
    if (funcionario && funcionario.trim() && funcionario !== '' && funcionario !== 'all') {
      q = q.eq('operador_nome', funcionario.trim());
    }

    const { data, error } = await q.range(from, from + PAGE_SIZE - 1);
    if (error) throw error;
    if (!data?.length) break;
    all.push(...(data as OSData[]));
    if (data.length < PAGE_SIZE) break;
  }

  return all;
};

export const fetchFuncionarios = async () => {
  const { data, error } = await supabase
    .from('funcionarios')
    .select(
      `
      nome,
      regime,
      ajuda_custo,
      vale_alimentacao,
      plano_saude,
      valores_historico:funcionarios_valores_historico(data_reajuste, valor_hora)
    `
    )
    .eq('ativo', true);

  if (error) throw error;

  const map = new Map<string, (typeof data)[0]>();
  for (const f of data ?? []) {
    map.set(f.nome.trim().toLowerCase(), f);
  }
  return map;
};

export const fetchClientes = async () => {
  const { data, error } = await supabase
    .from('clientes_cadastro')
    .select(
      `
      nome,
      valores_historico:clientes_valores_historico(data_reajuste, valor_hora)
    `
    );

  if (error) throw error;

  const map = new Map<string, (typeof data)[0]>();
  for (const c of data ?? []) {
    map.set(c.nome.trim().toLowerCase(), c);
  }
  return map;
};

export const fetchOSDoFuncionarioNoDia = async (
  operadorNome: string,
  dataReal: string
) => {
  const { data, error } = await supabase
    .from('ordens_servico')
    .select('numero, operador_nome')
    .eq('operador_nome', operadorNome)
    .eq('data_real', dataReal);

  if (error) throw error;
  return data || [];
};
